<script setup lang="ts">
import { computed, defineProps, onMounted, ref } from "vue";
import { IImageConfig } from "@/types/apartmentPlan";

const props = defineProps<{
  diagramConfig: IImageConfig | null;
  diagramComponent: string;
  rotationOffset: number;
}>();

const diagramImage = ref<HTMLImageElement | null>(null);

function loadDiagramImageAsset() {
  const img = new Image();
  img.onload = () => {
    diagramImage.value = img;
  };
  img.src = props.diagramComponent;
}

onMounted(() => {
  loadDiagramImageAsset();
});

const diagramComponentConfig = computed<IImageConfig | null>(() => {
  if (props.diagramConfig === null) {
    return null;
  }

  return {
    image: diagramImage.value,
    x: props.diagramConfig.x,
    y: props.diagramConfig.y,
    width: props.diagramConfig.width,
    height: props.diagramConfig.height,
    offsetY: props.diagramConfig.offsetY,
    offsetX: props.diagramConfig.offsetX,
    rotation: props.diagramConfig.rotation + 30 * props.rotationOffset,
    scaleX: props.diagramConfig.scaleX,
    scaleY: props.diagramConfig.scaleY,
  };
});
</script>

<template>
  <v-image :config="diagramComponentConfig" />
</template>
